module.exports = __webpack_public_path__ + "img/bottom-border.f1cf695c.svg";